import { Trans } from '@lingui/react/macro'
import { Paper, Text } from '@mantine/core'
import dayjs from 'dayjs'

interface BookingSummaryProps {
  selectedTime: Date
  selectedEndTime: Date
  cityLabel: string
}

export function BookingSummary({
  selectedTime,
  selectedEndTime,
  cityLabel,
}: BookingSummaryProps) {
  const formattedDate = dayjs(selectedTime).format('dddd, D.MM')
  const formattedTime = dayjs(selectedTime).format('HH:mm')
  const estimatedEndTime = dayjs(selectedEndTime).format('HH:mm')

  return (
    <Paper withBorder p="md" bg="gray.0">
      <Text size="sm" fw={500} mb="xs">
        <Trans>Your selected time</Trans>
      </Text>
      <Text size="sm">
        {formattedDate} <Trans>at</Trans> {formattedTime} ({cityLabel})
      </Text>
      <Text size="sm" c="dimmed" mt={4}>
        <Trans>Estimated end time at</Trans> {estimatedEndTime}
      </Text>
    </Paper>
  )
}
